import React, { useContext } from 'react'

import { LinkBank, LinkDetail, PageWrapper } from '@vividseats/vivid-ui-kit'

import RegionContext from '@/context/region'
import RelatedVenuesContext from '@/context/related-venues'
import type { Venue } from '@/types/app-types'

import styles from './styles.module.scss'

// Put region name in LinkBank title
const generateTitle = (regionName: string | undefined): string => {
    if (regionName) {
        return `More ${regionName} Venues`
    }

    // Fallback title
    return 'More Venues'
}

const mapVenuesLinks = (venues: Venue[]): LinkDetail[] => {
    return venues
        .map(({ id, name, webPath, organicUrl }) => ({ id, name, url: webPath ?? organicUrl } as LinkDetail))
        .sort((a, b) => a.name.localeCompare(b.name))
}

const MoreVenues: React.FC = () => {
    const {
        selectors: { region },
    } = useContext(RegionContext)

    const {
        selectors: { venues },
    } = useContext(RelatedVenuesContext)

    const venuesLinks = mapVenuesLinks(venues)

    return venuesLinks && venuesLinks.length > 0 ? (
        <PageWrapper className={styles.moreVenues} white withGutters withMobileGutters>
            <LinkBank title={generateTitle(region?.name)} links={venuesLinks} numberOfColumns={2} titleTextAs="h6" />
        </PageWrapper>
    ) : null
}

export default MoreVenues
